(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-information-blocks"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(e) {
  var trigger = e.target.closest('.metafield-variant-dropdown__trigger');
  if (trigger) {
    e.preventDefault();
    var dropdown = trigger.closest('.metafield-variant-dropdown');
    var isOpen = dropdown.hasAttribute('open');
    // Close all other dropdowns
    document.querySelectorAll('.metafield-variant-dropdown[open]').forEach(function(d) {
      d.removeAttribute('open');
      d.querySelector('.metafield-variant-dropdown__trigger').setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      dropdown.setAttribute('open', '');
      trigger.setAttribute('aria-expanded', 'true');
    }
    return;
  }
  // Close on outside click
  if (!e.target.closest('.metafield-variant-dropdown')) {
    document.querySelectorAll('.metafield-variant-dropdown[open]').forEach(function(d) {
      d.removeAttribute('open');
      d.querySelector('.metafield-variant-dropdown__trigger').setAttribute('aria-expanded', 'false');
    });
  }
});
  } catch(e) { console.error(e); }
})();

})();
